import { InputLabel, Grid } from '@material-ui/core';
import React, { Fragment } from 'react';
import { Wysiwyg } from 'v2/components/Shared/Wysiwyg';

import type { IForm } from 'v2/components/Shared/Content';

import type { AffiliateInstructions as AffiliateInstructionsClass } from '../../classes/Affiliates';

interface IProps extends IForm<AffiliateInstructionsClass> {}

const AffiliateInstructions = (props: IProps) => {
  const { values, setFieldValue } = props;
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel style={{ paddingBottom: '0.5rem' }}>Instruções para afiliados</InputLabel>
          <Wysiwyg value={values.affiliate_instructions} onChange={(v) => setFieldValue('affiliate_instructions', v)} />
        </Grid>
        <Grid item xs={12}>
          <InputLabel style={{ paddingBottom: '0.5rem' }}>Contrato para afiliados</InputLabel>
          <Wysiwyg value={values.affiliation_contract} onChange={(v) => setFieldValue('affiliation_contract', v)} />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default AffiliateInstructions;
